export default __webpack_public_path__ + "static/media/Astro_Southnode_Black.ed539d03.png";